export default __webpack_public_path__ + "static/media/T850MANC2.e75ef66f.pdf";